import * as React from 'react';
import { TileLayer } from 'react-leaflet';
import { getTileLayerUrl } from './get-tile-layer-url';
export function BuildingBaseLayerAllZoom({ theme }) {
    const tileset = `base_${theme}`;
    return React.createElement(TileLayer, { key: theme, url: getTileLayerUrl(tileset), minZoom: 1, maxZoom: 109, detectRetina: false });
}
